import type { CartItem, PriceSummary } from '@src/domains/cart/types/cart';
import { calculateItemTotalPriceSummary } from '@src/domains/cart/core/calculateItemTotalPriceSummary';

export const calculatePackageTotalPriceSummary = (items: CartItem[]): PriceSummary =>
  items.reduce(
    (acc, item) => {
      const { discount, previousPrice, total } = calculateItemTotalPriceSummary(item);

      return {
        total: acc.total + total,
        discount: acc.discount ? acc.discount + (discount ?? 0) : discount,
        previousPrice: acc.previousPrice ? acc.previousPrice + (previousPrice ?? 0) : previousPrice,
      };
    },
    { total: 0 } as PriceSummary,
  );
